import { BreakpointArray, Orientation } from '@thg-commerce/gravity-theme'
import { TextStyling } from '@thg-commerce/gravity-theme/typography/typography'
import { Order, ProductBlockComponents } from './types'

interface Components {
  titleLabel: {
    type: ProductBlockComponents
    order: Order
    title: {
      font: TextStyling
    }
  }
  productReview: {
    type: ProductBlockComponents
    order: Order
  }
  marketedSpecialOffer: {
    type: ProductBlockComponents
    order: Order
  }
  swatch: {
    type: ProductBlockComponents
    order: Order
  }
  iconsPrice: {
    type: ProductBlockComponents
    order: Order
  }
  description: {
    type: ProductBlockComponents
    order: Order
  }
  options: {
    type: ProductBlockComponents
    order: Order
  }
  productButton: {
    type: ProductBlockComponents
    order: Order
  }
  wishlistButton: {
    type: ProductBlockComponents
    order: Order
  }
}

export enum ProductBlockPriceDisplayStyle {
  CHEAPEST_PRICE = 'cheapest_price',
  PRICE_RANGE = 'price_range',
}

export interface Price {
  displayStyle: ProductBlockPriceDisplayStyle
  displayRRPText: boolean
  orientation: Orientation
}

export interface ProductBlockInterface {
  price: Price
  components: Components
}

// @TODO REBUILD-5572: Update to use aseptic ratio once REBUILD-5068 is released,
//  remove stylewith image from theme
export interface StyleWithInterface {
  image: {
    width: BreakpointArray<string>
    height: BreakpointArray<string>
  }
}

export const theme: ProductBlockInterface = {
  price: {
    displayStyle: ProductBlockPriceDisplayStyle.CHEAPEST_PRICE,
    displayRRPText: true,
    orientation: Orientation.HORIZONTAL,
  },
  components: {
    titleLabel: {
      type: ProductBlockComponents.TITLE_LABEL,
      order: Order.ONE,
      title: {
        font: {
          entry: 'bodyText',
          style: 'default',
          transform: 'none',
          textColor: '#333333',
          textDecoration: 'none',
        },
      },
    },
    productReview: {
      type: ProductBlockComponents.PRODUCT_REVIEW,
      order: Order.TWO,
    },
    marketedSpecialOffer: {
      type: ProductBlockComponents.MARKETED_SPECIAL_OFFER,
      order: Order.THREE,
    },
    swatch: {
      type: ProductBlockComponents.SWATCH,
      order: Order.FOUR,
    },
    iconsPrice: {
      type: ProductBlockComponents.ICONS_PRICE,
      order: Order.FIVE,
    },
    description: {
      type: ProductBlockComponents.DESCRIPTION,
      order: Order.SIX,
    },
    options: {
      type: ProductBlockComponents.OPTIONS,
      order: Order.SEVEN,
    },
    productButton: {
      type: ProductBlockComponents.PRODUCT_BUTTON,
      order: Order.EIGHT,
    },
    wishlistButton: {
      type: ProductBlockComponents.WISHLIST_BUTTON,
      order: Order.NINE,
    },
  },
}

// @TODO REBUILD-5572: Update to use aseptic ratio once REBUILD-5068 is released,
// remove stylewith image from theme
export const StyleWithTheme: StyleWithInterface = {
  image: {
    width: ['150px', '200px'],
    height: ['200px', '250px'],
  },
}
